import {Controller, useFieldArray, useFormContext} from "react-hook-form";
import {Button, Input, Select, Space} from "antd";
import {FormFieldError} from "../../../../../../../design-system/form-field";
import {CreateKycBasicFormStepFormValues} from "../../schema-validation";
import {CloseOutlined, PlusCircleFilled} from "@ant-design/icons";

export type KycSocialMediaOptions =
  | "Instagram"
  | "LinkedIn"
  | "Facebook"
  | "Twitter/X"
  | "YouTube"
  | "TikTok"
  | "Snapchat"
  | "Twitch"
  | "Kick"
  | "Pinterest"
  | "Threads";

export const KYC_SOCIAL_MEDIA_OPTIONS: KycSocialMediaOptions[] = [
  "Instagram",
  "LinkedIn",
  "Facebook",
  "Twitter/X",
  "YouTube",
  "TikTok",
  "Snapchat",
  "Twitch",
  "Kick",
  "Pinterest",
  "Threads",
];

export function KycSocialLinksFormField() {
  const {control, watch, formState, trigger} =
    useFormContext<CreateKycBasicFormStepFormValues>();
  const {fields, append, remove} = useFieldArray({
    control,
    name: "socialLinks",
  });

  const watchLinks = watch("socialLinks");

  const selectedPlatforms = watchLinks.map((link) => link.name).filter(Boolean);

  const handleAppend = () => {
    const nextAvailable = KYC_SOCIAL_MEDIA_OPTIONS.find(
      (option) => !selectedPlatforms.includes(option)
    );
    if (nextAvailable) {
      append({name: nextAvailable, link: ""});
      trigger("socialLinks");
    }
  };
  return (
    <div>
      <Space size={8} direction="vertical" style={{display: "flex"}}>
        <p>Social media links or websites</p>
        {fields.slice(0, 12).map((item, index) => (
          <div key={item.id} style={{display: "flex", gap: "1.6rem"}}>
            {/* // <Space size={16} key={item.id}> */}
            <div style={{flex: "1"}}>
              <Controller
                control={control}
                name={`socialLinks.${index}.link`}
                render={({
                  field: {onChange, value, ref, onBlur},
                  fieldState: {error},
                }) => (
                  <Space size={8} direction="vertical" style={{display: "flex"}}>
                    <Input
                      // id={id}
                      status={error?.message ? "error" : ""}
                      onChange={onChange}
                      onBlur={onBlur}
                      size="large"
                      value={value === null ? undefined : value}
                      placeholder="Enter a valid link"
                      ref={ref}
                      addonBefore={
                        <Controller
                          control={control}
                          name={`socialLinks.${index}.name`}
                          render={({
                            field: {onChange, value, ref},
                            fieldState: {error},
                          }) => (
                            <>
                              <Select
                                onChange={onChange}
                                value={value}
                                ref={ref}
                                size="large"
                                status={error?.message ? "error" : ""}
                                showSearch={false}
                                notFoundContent={null}
                                placeholder={""}
                                options={KYC_SOCIAL_MEDIA_OPTIONS.map((opt) => {
                                  const isSelected = selectedPlatforms.includes(opt);
                                  const isCurrent = opt === value;
                                  return {
                                    value: opt,
                                    label: opt,
                                    disabled: isSelected && !isCurrent,
                                  };
                                })}
                              />
                              <FormFieldError errorMessage={error?.message} />
                            </>
                          )}
                        />
                      }
                    />
                    <FormFieldError errorMessage={error?.message} />
                  </Space>
                )}
              />
              {/* <CustomInputComponent
              id={`socials[${index}].value`}
              name={`socials[${index}].link`}
              placeholder="your profile link"
              error={errors.socials?.[index]?.link?.message}
              control={control}
              // style={{width: '9'}}
              addonBefore={
                <Controller
                  control={control}
                  name={`socials.${index}.name`}
                  render={({field: {onChange, value, ref}}) => (
                    <>
                      <Select
                        onChange={(val) =>
                          handleSocialSelectOnChange(
                            socialsArrayValue,
                            setSocialOptions,
                            onChange,
                            val
                          )
                        }
                        value={value}
                        ref={ref}
                        size="large"
                        status={errors.socials?.[index]?.name?.message ? "error" : ""}
                        showSearch={false}
                        notFoundContent={null}
                        placeholder={""}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option!.children as unknown as string)
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {socialOptions.map((option, optionIdx: number | string) => (
                          <Option key={optionIdx} value={option.name}>
                            {option.name}
                          </Option>
                        ))}
                      </Select>
                      {errors.socials?.[index]?.name?.message && (
                        <div role="alert" className="ant-form-item-explain-error">
                          {errors.socials?.[index]?.name?.message}
                        </div>
                      )}
                    </>
                  )}
                />
              }
            /> */}
            </div>

            <Button
              onClick={() => remove(index)}
              type="link"
              shape="circle"
              icon={<CloseOutlined />}
              size="small"
            />
            {/* </Space> */}
          </div>
        ))}

        {selectedPlatforms.length <= KYC_SOCIAL_MEDIA_OPTIONS.length && (
          <Button
            size="small"
            disabled={selectedPlatforms.length >= KYC_SOCIAL_MEDIA_OPTIONS.length}
            icon={<PlusCircleFilled />}
            onClick={handleAppend}
          >
            Add links
          </Button>
        )}
        {Array.isArray(formState.errors.socialLinks) === false &&
          formState.errors.socialLinks?.message && (
            <FormFieldError errorMessage={formState.errors.socialLinks?.message} />
          )}
        {/* <FormField
        id="socailLinks"
        label="Social media links or websites"
        renderInput={(id) => (
          <Controller
            control={control}
            name="socialLinks"
            render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
              <Space size={16} direction="vertical" style={{display: "flex"}}>
                <Input
                  id={id}
                  status={error?.message ? "error" : ""}
                  onChange={onChange}
                  showSearch
                  onBlur={onBlur}
                  size="large"
                  value={value === null ? undefined : value}
                  placeholder="Enter a valid link"
                  ref={ref}
                />
                <FormFieldError errorMessage={error?.message} />
              </Space>
            )}
          />
        )}
      /> */}
      </Space>
    </div>
  );
}
